export const SELECT_MIN_WIDTH = '100px'
